import { apiRequest } from "./backendApi";

export type AppRole = "superadmin" | "admin";

export type MeResponse = {
  uid: string;
  email?: string;
  role: AppRole;
};

export const authApi = {
  getMe: () => apiRequest<MeResponse>("GET", "/api/me"),
};
